import React, { useEffect, useState } from "react";
import ReactExport from "react-export-excel";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
// import {ExcelFile, ExcelSheet} from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const ExcelRow = ReactExport.ExcelFile.ExcelRow;

export default function DownloadPilihanGanda(props) {
  const [excelData, setexcelData] = useState([]);
  const [jawaban, setjawaban] = useState([]);
  // const [dataSoal, setDataSoal] = useState(props.dataSoal);

  let jumlah = Array.from({ length: props.jumlahSoal }, (x, i) => i);
  useEffect(() => {
    let data = props.dataKuesioner;
    let excel = [
      {
        title: "ID Kuesioner",
        value: data.id,
      },
      {
        title: "Bentuk",
        value: data.tipe,
      },
      {
        title: "Nama Kuis",
        value: data.judul,
      },
      {
        title: "Keterangan",
        value: data.keterangan,
      },
      {
        title: "Tanggal Buka",
        value: data.tanggal_buka,
      },
      {
        title: "Tanggal Tutup",
        value: data.tanggal_tutup,
      },
    ];

    setexcelData(excel);
    sortJawaban();
  }, []);

  function sortJawaban(params) {
    let data = props.dataSoal;
    let result = [];

    data.forEach((e, idx) => {
      let x = { no: idx + 1, name: e.name, username: e.username };
      e.jawaban.forEach((y, idx) => {
        x[`v${idx + 1}`] = y;
      });

      result.push(x);
    });

    setjawaban(result);
  }

  const camelCase = (str) => {
    return str.substring(0, 1).toUpperCase() + str.substring(1);
  };

  const dataSoal = [{ id: 1, name: "asw", username: "uuuu", v1: "uiuiui" }];

  const filterColumns = (data) => {
    // Get column names
    const columns = Object.keys(data[0]);

    // OR use the below line instead of the above if you want to filter by index
    // columns.shift()

    return columns; // OR return columns: ;
  };


  return (
    <>
      {jawaban.length > 0 ? (
        <ExcelFile
          filename={props.dataKuesioner.judul}
          element={
            <button className="px-4 py-2 bg-green-500 rounded-lg text-white">
              Export Excel
            </button>
          }
        >
          <ExcelSheet data={excelData} name="detail kuesioner">
            <ExcelColumn label="" value="title" />
            <ExcelColumn label="" value="value" />
          </ExcelSheet>

          <ExcelSheet data={jawaban} name="Jawaban">
            {filterColumns(jawaban).map((col, idx) => {
              return (
                <ExcelColumn
                  label={idx > 2 ? col.replace(/\D/, "") : col}
                  value={col}
                />
              );
            })}
          </ExcelSheet>

          {/* <ExcelSheet data={tes} name="hasil kuesioner">
        
        <ExcelColumn label="No" value="no" />
        <ExcelColumn label="Username" value="username" />
        <ExcelColumn label="Nama User" value="nama" />
        {
            [...Array(props.jumlahSoal).keys()].map(x => {
                <ExcelColumn label={`${x + 1}`} value={`${x + 1}`} />
            })
        }
      </ExcelSheet> */}
          {/* <ExcelSheet dataSet={multiDataSet} name="Organization"/> */}
        </ExcelFile>
      ) : null}
    </>
  );
}
